document.addEventListener("DOMContentLoaded", function () {
  const detailsList = document.querySelectorAll("details");

  detailsList.forEach((detail) => {

    detail.addEventListener("toggle", function (e) {

      // 開いた時だけ処理
      if (!detail.open) return;

      // 他を閉じる
      detailsList.forEach((other) => {
        if (other !== detail) {
          other.removeAttribute("open");
        }
      });

      // スクロール（少し遅らせてDOM安定後）
      setTimeout(() => {
        const y =
          detail.getBoundingClientRect().top +
          window.pageYOffset -
          80; // ヘッダー対策

        window.scrollTo({
          top: y,
          behavior: "smooth"
        });
      }, 100);

    });

  });
});


document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();

    const target = document.querySelector(this.getAttribute("href"));

    if (target) {
      const y =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        80;

      window.scrollTo({
        top: y,
        behavior: "smooth"
      });
    }
  });
});